import {vec3, quat} from "_src/libs/gl-matrix";
import {objectType} from "_src/constants";

export default class {

  constructor() {
    this.trans = null;
    this.quat  = null;
    this.scale = null;
  }

  apply(object) {
    if (object.type !== objectType.GROUP) {
      object.model.copyTranslation(this.trans);
      object.model.copyRotation(this.quat);
      object.model.copyScale(this.scale);
      object.model.updateMatrix();
    }
  }

  appendData(object) {
    if (object.type !== objectType.GROUP) {
      this.trans = object.model.getTranslation(vec3.create());
      this.scale = object.model.getScale(vec3.create());
      this.quat  = object.model.getRotation(quat.create());
    }
  }

}
